// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__WBgu9","content":"Dialog_content__5KrM1","header":"Dialog_header__Q+Yoz","title":"Dialog_title__lfHGX","footer":"Dialog_footer__+IV9W"};